import {Component, Input, Output, EventEmitter, OnInit, HostListener} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AppToastrService, ChatService, StorageService, UsersService} from '../../../services';
import {DictionaryService} from '../../../services';

@Component({
  selector: 'app-request-service-popup',
  templateUrl: './request-service.html'
})
export class RequestServiceComponent implements OnInit {
  @Input() types: any[];
  @Input() typeAction: string;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();

  requestMessageCtrl: FormControl;
  //serviceCtrl: FormControl;
  form: FormGroup;
  submitPressed: boolean;
  clientID: number;
  submitting: boolean;
  services: any[];

  @HostListener('window:keyup', ['$event']) onKey(event) {
    if (event.keyCode === 27) {
      this.onClose();
    }
  }


  constructor(private toast: AppToastrService,
              private usersService: UsersService,
              private fb: FormBuilder,
              private dictionaryService: DictionaryService,
              private chat: ChatService,
              private storage: StorageService) {
    this.clientID = this.storage.userId;
  }

  ngOnInit() {
    //this.getServices();
    this.prepareForm();
  }

  getServices() {
    this.dictionaryService.getServices().subscribe((res) => {
      if (res) {
        this.services = res;
        console.log('!!!!!this.services', this.services)
      }
    });
  }

  private prepareForm() {
    //this.serviceCtrl = this.fb.control( '', [Validators.required]);
    this.requestMessageCtrl = this.fb.control('', );
    this.form = this.fb.group({
      //service: this.serviceCtrl,
      requestMessage: this.requestMessageCtrl,
    });
  }

  onClose() {
    this.notify.emit({type: 'close'});
  }

  onSubmit() {
    this.submitting = true;
    if (this.form.valid && !this.submitPressed) {
      const msg = this.typeAction === 'add' ? 'Здравствуйте, прошу добавить в путешествие новую услугу:\n' : 'Здравствуйте, прошу отменить услугу:\n';
      const data = {
        message: msg + this.requestMessageCtrl.value,
        agent: 'request',
        id: this.clientID,
        reply_to: 'request'
      };
      this.chat.createMessage(data).subscribe((msg) => {
        this.requestMessageCtrl.setValue(null);
        const data = {
          title: 'Ваш запрос отправлен менеджеру'
        };
        this.toast.showToast(data);
        this.onClose();
      }, (err) => {
        const data = {
          title: 'Произошла ошибка, пожалуйста попробуйте еще раз'
        };
        this.toast.showErrorToast(data);
      });
    } else {
      this.submitPressed = false;
    }
  }
}
